import React from "react";
import { DatePicker, Space } from "antd";

const { RangePicker } = DatePicker;

const DateRangePicker = ({ onChange }) => (
  <Space direction="vertical" size={4}>
    <RangePicker
      onChange={onChange}
      placeholder={["Start Date", "End Date"]} 
    />
  </Space>
);

export default DateRangePicker;
